import { IKnmEvent248 } from '../../../../../APIPackage/KnmModule/interfaces/IKnmEvent248';
import { IKnmSubject248 } from '../../../../../APIPackage/KnmModule/interfaces/IKnmSubject248';
import { IPmSubject } from '../../../../../APIPackage/KnmModule/interfaces/IPm';
import { IKnmObject248 } from '../../../../../APIPackage/KnmModule/interfaces/IKnmObject248';
import { IKnmRequirementsNpa248 } from '../../../../../APIPackage/KnmModule/interfaces/IKnmRequirementsNpa248';
import { IKnmRequirementsNpa } from '../../../../../APIPackage/KnmModule/interfaces/IKnmRequirementsNpa';

export const convertEventsFromLink = (events: IKnmEvent248[] | null | undefined): IKnmEvent248[] | null => {
  return (
    events?.map(event => ({
      ...event,
      suspension: null,
      originalStopDate: undefined,
      isFilledFromLink: true,
    })) ?? null
  );
};

export const convertErknmOrganizationsFromLink = (
  organizations: IKnmSubject248[] | null | undefined,
): IKnmSubject248[] | null => {
  return (
    organizations?.map(org => ({
      ...org,
      isFilledFromLink: true,
    })) ?? null
  );
};

export const convertPmOrganizationsFromLink = (organization: IPmSubject | null | undefined): IPmSubject[] | null => {
  return organization
    ? [
        {
          ...organization,
          isFilledFromLink: true,
        },
      ]
    : [];
};

export const convertObjectsFromLink = (objects: IKnmObject248[] | null | undefined): IKnmObject248[] | null => {
  return (
    objects?.map(obj => ({
      ...obj,
      isFilledFromLink: true,
    })) ?? null
  );
};

export const convertErknmRequirementsFromLink = (
  requirements: IKnmRequirementsNpa248[] | null | undefined,
): IKnmRequirementsNpa248[] | null => {
  return (
    requirements?.map(requirement => ({
      ...requirement,
      isFilledFromLink: true,
    })) ?? null
  );
};

export const convertPmRequirementsFromLink = (
  requirements: IKnmRequirementsNpa[] | null | undefined,
): IKnmRequirementsNpa[] | null => {
  return (
    requirements?.map(requirement => ({
      ...requirement,
      isFilledFromLink: true,
    })) ?? null
  );
};
